import { createContext } from 'react';

const AppContext = createContext({
  rasaServerUrl: '',
  initialPayload: '/hello',
  metadata: {},
  botAvatar: 'https://unpkg.com/scout-chatbot@latestCTM_Logo.jpg',
  widgetColor: '',
  botTitle: '',
  botSubTitle: '',
  userId: null,
  textColor: '',
  userMsgBackgroundColor: '',
  botMsgBackgroundColor: '',
  botMsgColor: '',
  // userMsgColor: "",
  botResponseDelay: '',
  buttonsCss: {},
  chatHeaderCss: {},
  errorMessages: [],
  embedded: false
});

export default AppContext;
